<template>
    <div>
        <div v-if="!currentPost" class="posts-wrapper">
            <br>
            <br>
            <br>
            <h2 class="gradiented">{{tr.publications}}</h2>
            <i-paginator v-if="paginate" :page="page" :records="total" :perPage="12" @input="(page)=>{setPage(page)}" />
            <div class="container">
                <div class="posts row ">
                    <div class="post col-sm-6 col-md-4" v-for="(post,index) in posts.filter(p=>p.content[lang].title).slice(perPage*(page-1),perPage*page)" :key="index" @click="openPost(post)">
                        <div class="preview" :style="{backgroundImage:`url(${post.preview || 'http://content.iwep.kz/default-image.png'}?w=350)`}"><img src="data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAABCAQAAABeK7cBAAAAC0lEQVR42mNkAAIAAAoAAv/lxKUAAAAASUVORK5CYII=" class="stretch"></div>
                            <h3>{{post.content[lang].title}}</h3>
                            <p class='short'>{{post.content[lang].short | short(120)}}</p>
                            <hr>
                            <span class="date number">{{post.date | date("D")}}</span>
                            <div class="author" v-for="(author,idx) in post.authors" :key="idx">
                                <div class="avatar" :style="{backgroundImage:`url(${author.image})`}"><img class="stretch" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"></div>
                                    <div class="name">{{author.name}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <i-paginator v-if="paginate" :page="page" :records="total" :perPage="12" @input="(page)=>{setPage(page)}" />
                </div>
                <div class="i-post" v-if="currentPost">
                    <post-back :title="currentPost.content[lang].title" 
                               :background§="currentPost.preview" 
                               :subtitle="currentPost.content[lang].subtitle"
                               :author="currentPost.content && currentPost.content.ru&&currentPost.content.ru.image_source"
                            />
                    <div class="post-wrapper container" v-if="currentPost" @click="openContent">
                        <div v-if="!currentPost.content[lang].text">
                            <div>
                                <div class="div" style="font-size:32px;text-align:center;padding:140px 0;">
                                    {{tr.sorry_not_available}}
                                </div>
                            </div>
                        </div>
                        <div class="container post-content-container" v-if="currentPost.content[lang].text" @click="openContent">
                            <div class="text-right" style='font-size:18px;'>
                                <b>{{currentPost.content[lang].subtitle}}</b>
                            </div>
                            <div class="post-content" id="main-view" v-html="currentPost.content[lang].text.toHTML()"></div>
                            <!-- <p v-if='currentPost.source' style='text-align:right'>{{tr.source}}: 
                <a :href="currentPost.source" target="_blank" >{{url(currentPost.source).get('hostname')}}</a>
            </p> -->
                        </div>
                    </div>
                </div>
            </div>
</template>
<script>
//import posts from "../assets/json/posts.json";
//import experts from "../assets/json/experts.json";
import iPaginator from "./i-paginator.vue";
import PostBack from "./i-post-back.vue";
export default {
    components: { iPaginator, PostBack },
    name: 'post-grid',
    props: {
        paginate: { type: Boolean, default: true },
        posts: { type: Array, default () { return [] } },
        total: { type: Number, default: 0 },
    },
    data() {
        return {
            page: 1,
            perPage: 12,
            currentPostId: false
        }
    },
    watch: {
        $route(nw, ol) {
            if (nw.params.id) {
                this.currentPostId = nw.params.id;
            } else this.currentPostId = false;
        }
    },
    methods: {
        openPost(post) {
            //this.$store.commit('viewPost',post);
            location.href = "#/posts/" + post._id + '/#header';
            this.$emit('onOpen', post)
        },
        setPage(page) {
            console.log("!!!", page);
            this.page = page;
            //this.$route.query.page = page;
            this.$router.push({ query: { page } })
            //document.documentElement.scrollTop=0;
            //this.$store.dispatch('loadPosts', (page-1)*9);
        },
        openContent(e) {
            //console.log(e)

            let self = this;
            console.log(e)
            document.getElementById("main-view").addEventListener('click', (e) => {
                //console.log("CLICK",e);
                //alert(1);
                //e.preventDefault();
                console.log(e)
                //e.preventDefault();
                if (e.target.tagName == "A") {
                    console.log(e);
                    e.trigger('click');

                }

                if (e.target.tagName == "IMG") {
                    //e.preventDefault();
                    let postContent = document.getElementsByClassName("post-content")[0];
                    var all_img = postContent.getElementsByTagName('img');
                    console.log(all_img, postContent);
                    let list = [];
                    for (let i = 0; i < all_img.length; i++) {
                        let img = all_img[i];
                        list.push({ src: img.src, title: img.title, "date": "2018-06-25T03:17:22.000Z", "description": "" });
                    }
                    console.log(list)
                    let foundIndex = list.findIndex((i) => {
                        if (i.src === e.target.src) return true;
                        else return false;
                    });

                    self.$store.commit('openPhoto', { list, index: foundIndex ? foundIndex : 0 });
                }
            });
        }
    },
    mounted() {
        /*let { page } = this.$route.query;
        if (page) this.setPage(parseInt(page));
        if (this.$route.params.id) {
            let { id } = this.$route.params;
            this.currentPostId = id;
        }*/
    },
    computed: {
        currentPost() {
            if (this.currentPostId) return this.posts.findById(this.currentPostId);
            else return false;
        },
        //posts(){return this.$store.state.posts.list;},
        //total(){return this.$store.state.posts.total;},
        lang() { return this.$store.state.lang; },
        tr() { return this.$store.getters.translates; }
    }
}
</script>
<style lang="css" scoped>
.posts-wrappers h2 {
    font-weight: normal;
    padding: 0 10px;
    text-align: center;
    /*border-left:3px solid lightgrey;*/
    /* display: inline-block;*/
    margin-left: 20px;
    text-align: center;
    font-size: 28px;
}

.posts {
    text-align: center;
}

.post {
    /* min-width: 300px;*/
    /*max-width: 300px;*/
    /*border:1px solid lightgrey;*/
    padding: 12px;
    display: inline-block;
    vertical-align: top;
    /*margin:5px;*/
    border-radius: 2px;
    text-align: left;
    line-height: 1.5;
    margin-bottom: 16px;

}

.post:hover {
    background: whitesmoke;
    cursor: pointer;
    /*transform:scale(1.05);*/
    transition: 0.2s all ease;
}

.post h3 {
    font-size: 20px;
    font-weight: normal;
    line-height: 1.2;
}

.post img {
    max-width: 100%;
}

.post .preview {
    background-size: cover;
    background-position: center;
}

.post hr {
    height: 0;
    border: none;
    border-bottom: 1px solid lightgrey;

}

.post .short {
    font-size: 18px;
    text-align: left;
    text-align: justify;
}

.post .date {
    font-size: 12px;
    color: grey;
    display: block;
    text-align: right;
}

.post .author .avatar {
    width: 32px;
}

.post .author .name {
    font-size: 12px;
    display: inline-block;
    vertical-align: middle;
}

.paginator {
    text-align: center;
    padding-bottom: 10px;
}











.post {
    /*position: fixed;*/
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 8;
    background: white;
    /*overflow-y: scroll;*/

}

.post>div {}

.post .post-content-container {
    padding-top: 60px;
    padding-bottom: 120px;
}

.post-content {
    /*max-width: 820px;*/
    padding-left: 24px;
    white-space: pre-line;
}

@media(max-width:768px) {
    .post-content {
        border-left: none;
        padding: 0;
        padding: 0 12px;
    }

    .last-publications {
        margin-left: auto;
    }

    h3.pub-title {
        padding-left: 0;
        font-size: 26px;
    }

    .post .title {
        font-size: 22px;
    }

    .pub {
        max-width: 90%;
        margin: 0 auto 32px auto;
    }
}
</style>
<style>
.post-content a {
    text-decoration: none;
}

.post-content img {
    max-width: 100%;
    /*margin:18px 24px !important;*/
    display: block !important;
    text-align: middle;
    border: 2px solid white;
    box-shadow: 1px 1px 8px grey;
    height: auto;
    margin: 24px auto;
    /*margin-left:-80px;*/
}

.post-content iframe {
    max-width: 100%;

}

.post-content,
.post-content * {
    /*font-family: "Times New Roman", serif !important;*/
    /*font-family: 'Merriweather', serif;*/
    font-size: 18px;
    line-height: 1.5;
    text-align: justify;
}

.pub {
    margin: 0 0 22px 0px;
    cursor: pointer;
    font-size: 14px;
    text-align: center;
}

.pub img {
    max-width: 100%;
}

.last-publications {
    margin-left: 42px;
}


.post-content-container {
    padding: 60px 0;
}

h3.pub-title {
    padding-left: 43px;
}
</style>